/**
 * Tipos y constantes para el manejo de monedas en la aplicación
 */

export type Currency = 'ARS' | 'USD';

export interface CurrencyOption {
  value: Currency;
  label: string;
  symbol: string;
}

export const CURRENCIES: CurrencyOption[] = [
  {
    value: 'ARS',
    label: 'Pesos Argentinos',
    symbol: 'ARS',
  },
  {
    value: 'USD',
    label: 'Dólares Estadounidenses',
    symbol: 'USD',
  },
];

export const DEFAULT_CURRENCY: Currency = 'ARS';

/**
 * Obtiene la información de una moneda por su valor
 */
export const getCurrencyInfo = (
  currency: Currency,
): CurrencyOption | undefined => {
  return CURRENCIES.find((c) => c.value === currency);
};

/**
 * Obtiene el símbolo de una moneda
 */
export const getCurrencySymbol = (currency: Currency): string => {
  return getCurrencyInfo(currency)?.symbol || currency;
};
